import api from './client'
import type { Notification } from '../types'

export const notificationsApi = {
  listNotifications: (params?: { limit?: number; offset?: number }) =>
    api.get<{ data: Notification[] }>('/notifications', { params }),

  getUnreadCount: () => api.get<{ data: { count: number } }>('/notifications/unread-count'),

  markRead: (id: string) => api.put(`/notifications/${id}/read`),

  markAllRead: () => api.put('/notifications/mark-all-read'),
}
